import { createFileRoute } from '@tanstack/react-router';

import { QuoteRequestTemplateEditPage } from '@/areas/quote-requests/QuoteRequestTemplates/QuoteRequestTemplateEditPage';
import { canManageSourcingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/quote-request/$quoteRequestTemplateId/edit')({
    staticData: { access: { permissions: canManageSourcingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <QuoteRequestTemplateEditPage {...pathParams} />;
}
